module.exports = __webpack_public_path__ + "img/dental-office-tour-hallway.ce4455d9.jpeg";